<template>
  <div class="ui-chips" role="group" :aria-label="label || null" :aria-labelledby="labelledby || null">
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      class="ui-toggle"
      :aria-pressed="String(isOn(option))"
      :disabled="option.disabled || null"
      :title="option.title || null"
      @click="pick(option)"
    >
      <slot name="option" :option="option" :active="isOn(option)">
        <i v-if="option.dot" class="ui-dot" :style="{ background: option.dot }"></i>
        {{ option.label }}
        <b v-if="option.count !== undefined && option.count !== null" class="ui-num">{{ option.count }}</b>
      </slot>
    </button>
  </div>
</template>

<script>
/**
 * Grupa izbora-oznaka (filter): jedan izbor (v-model je vrijednost) ili više njih (multiple: v-model je niz vrijednosti).
 * options: [{ value, label, count?, dot?, title?, disabled? }]; count se piše podebljano iza natpisa (npr. "Svi 24"), dot je boja tačke ispred natpisa.
 * Slot `option` ({ option, active }) mijenja sadržaj dugmeta (značka smjene, ikona...). Jedna oznaka bez grupe je <ui-toggle>.
 */
export default {
  name: "UiChips",
  props: {
    options: { type: Array, required: true },
    value: { type: null, default: null },
    multiple: { type: Boolean, default: false },
    label: { type: String, default: "" },
    labelledby: { type: String, default: "" },
  },
  methods: {
    chosen() {
      return Array.isArray(this.value) ? this.value : [];
    },
    isOn(option) {
      return this.multiple ? this.chosen().includes(option.value) : this.value === option.value;
    },
    pick(option) {
      if (!this.multiple) {
        this.$emit("input", option.value);
        return;
      }
      const list = this.chosen();
      this.$emit("input", list.includes(option.value) ? list.filter((value) => value !== option.value) : [...list, option.value]);
    },
  },
};
</script>
